import { getCookie as get, removeCookie as clear, setCookieRaw as set } from '@/utils/cookies/cookies';

const COOKIE = 'mindboxAuth';

export const getCookie = (): string | undefined => get(COOKIE);

export const setCookie = (age: number) => {
  set(COOKIE, 1, age);
};

export const removeCookie = () => clear(COOKIE);
